// Helpers to detect and embed external video URLs (YouTube + Vimeo)

export function detectExternalVideo(url) {
  if (!url || typeof url !== "string") return null;
  const u = url.trim();

  // YouTube: youtu.be/ID  •  youtube.com/watch?v=ID  •  youtube.com/embed/ID  •  youtube.com/shorts/ID
  const yt =
    u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt) return { provider: "youtube", id: yt[1], embed: `https://www.youtube.com/embed/${yt[1]}?rel=0`, thumb: `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg` };

  // Vimeo: vimeo.com/ID
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d{6,})/);
  if (vm) return { provider: "vimeo", id: vm[1], embed: `https://player.vimeo.com/video/${vm[1]}`, thumb: null };

  return null;
}

export function isExternalVideo(item) {
  if (!item) return false;
  if (item.type === "video-url") return true;
  return !!detectExternalVideo(item.url);
}
